import { Product } from "@/api/product-api";
import { Accessories } from "@/components/tactsuit/components/buy-tactsuit/Accessories";
import { Accessory } from "@/store/useBuyTactSuit";
import { ProductUtil } from "@/utils/ProductUtil";
import { useTrans } from "@/utils/useTrans";

export function AccessoriesSelect({
  accessories,
  selectedAccessories,
  product,
  onChange,
}: {
  product: Product;
  selectedAccessories: Accessory[];
  onChange: (selected: Accessory) => void;
  accessories: Product[];
}) {
  const { t } = useTrans(["shop"]);

  return (
    // 피그마 28715:139644 `Lists` — Notice(h58) → 아이템 갭 12.
    // 헤더→Notice 20px 는 AccordionContent 의 pt-5 가 담당하므로 여기서 mt 를
    // 또 주면 32px 로 벌어진다.
    <div className="flex flex-col gap-3">
      {ProductUtil.isAudioAccessoryIncluded(product) && (
        // Size 섹션 Notice(28715:139562)와 같은 박스 — bg coolgray-10, r8, p20,
        // 본문 Body/Medium 14/18 tracking .25
        <p className="rounded-lg bg-coolgray-10 p-5 text-base tracking-[0.25px] text-coolgray-90">
          {t(`Audio Accessories (Audio cable & Y Splitter) is included`)}
        </p>
      )}
      <div>
        <Accessories
          accessories={accessories}
          selectedAccessories={selectedAccessories}
          onChange={(item) => onChange({ ...item, type: "non-badge" })}
        />
      </div>
    </div>
  );
}
